module.exports = __webpack_public_path__ + "static/personal-loans-gem-nz-3befe8198c0525adfde1db815e54b4c3.png";